// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1NIkU","icon":"styles_icon__2e4jB"};